import { jsx } from "react/jsx-runtime";
import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";
import { validateTidalLicense } from "../../base/index.js";
function EditLocationAlt(props) {
  return /* @__PURE__ */ jsx(
    EditLocationAltIcon,
    {
      "data-testid": "EditLocationAlt",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "EditLocationAlt",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
EditLocationAlt.tidalIconMeta = {
  categories: "map,location,time",
  name: "EditLocationAlt"
};
validateTidalLicense();
export {
  EditLocationAlt
};
//# sourceMappingURL=EditLocationAlt.js.map
